import React, { useEffect, useState } from "react";
import {
    useAreaData,
    usePoliceStationData,
    useUserDetailsExcel,
    useUserDetailsPagination,
    useZoneData
} from "../../API_Master/GetAPI";
import Cookies from "js-cookie";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import PageEntries from "../../Components/PageEntries";
import PaginationButtons from "../../Components/PaginationButtons";
import { exportToExcel, notifyError, validateStartAndEndDate } from "../../HelperMethods";
import { toast } from "react-toastify";
import { NIGHT_EYE_IMG_URL } from "../../Process";
import ShopReportModal from "../../Components/ShopReportModel";
import PageCountSelect from "../../Components/PageCountSelect";
import NoDataFound from "../../Components/NoDataFound";
import ShopDetailModal from "../../Components/ShopProfileView";
import { mainRouteInitial } from "../../Data/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import { handleEditUserID } from "../../Redux/Slices/ProjectSlice";
import { useDispatch } from "react-redux";


const ShimmerRow = () => (
    <tr className="animate-pulse">
        <td className="py-5 px-3 pl-6">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
        <td className="py-5 px-3">
            <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
        </td>
    </tr>
);
const ViewUserList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [shopProfileDetailView, setShopProfileDetailView] = useState({});
    const [openShopDetails, setOpenShopDetails] = useState(false);
    const [isFiltersOpen, setIsFiltersOpen] = useState(false); // ← starts collapsed
    const [currentPage, setCurrentPage] = useState(0); // index: 0 = page 1
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const [selectedShop, setSelectedShop] = useState(null);
    const location = useLocation();

    const receivedFilterData = location?.state?.filterData;
    console.log("sdfjskdsdfsdfsdfjsksafd", receivedFilterData);
    const [selectedImage, setSelectedImage] = useState(null);
    const [filterData, setFilterData] = useState({
        cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
        zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
        policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
        areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
        userName: "",
        startDate: receivedFilterData?.["startDate"] || "",
        endDate: receivedFilterData?.["startDate"] || "",
    });

    const [modelFilter, setModelFilter] = useState({
        cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
        zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
        policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
        areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
        userName: "",
        startDate: receivedFilterData?.["startDate"] || "",
        endDate: receivedFilterData?.["startDate"] || "",
    });

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useUserDetailsPagination(rowsPerPage, filterData);

    const { mutate: exportUser, isPending: isExporting } = useUserDetailsExcel();

    const pages = data?.pages || [];
    const totalCount = data?.pages[0]?.TotalCount || 0;
    const currentItems = data?.pages[currentPage]?.data || [];

    const start = currentPage * rowsPerPage + 1;
    const end = Math.min(start + currentItems.length - 1, totalCount);




    const handleFilterSearch = () => {
        console.log(modelFilter, "modelFiltermodelFilter");
        if (!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)) {
            return;
        }
        setFilterData(modelFilter);
    };
    const goToPage = async (index) => {
        if (pages[index]) {
            setCurrentPage(index);
        } else if (hasNextPage) {
            await fetchNextPage(); // loads next page
            setCurrentPage(index);
        }
    };

    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };
    const handleRowsChange = async (e) => {
        const limit = parseInt(e.target.value);
        setRowsPerPage(limit);
        setCurrentPage(0);
        await refetch(); // reload from start
    };
    const handleExport = (exportType) => {
        toast.dismiss();

        exportUser(filterData, {
            onSuccess: (userMaster) => {
                if (!userMaster?.length) {
                    return notifyError("No Data Found");
                }

                const exportData = userMaster.map((user, index) => {



                    // ── Amenities ──────────────────────────────────────────────────────
                    // Two separate columns — only show names that match the status
                    const areaDetails =
                        (user.UserAreaDetail || []).map((a) => a.AreaName?.trim() || "Unknown").join(", ") || "-";
                    const policeStationDetails =
                        (user.UserPoliceStationDetail || []).map((a) => a.PoliceStation?.trim() || "Unknown").join(", ") || "-";
                    const zoneDetails =
                        (user.UserZoneDetail || []).map((a) => a.ZoneName?.trim() || "Unknown").join(", ") || "-";
                    const cityDetails =
                        (user.UserCityDetail || []).map((a) => a.CityName?.trim() || "Unknown").join(", ") || "-";



                    return {
                        "Sr No": index + 1,
                        // "Shop Unique ID": shop.ShopUniqueID || "-",
                        "Role": user?.UserRoleDetail?.[0]?.UserRole || "-",
                        // First Shop User
                        "Password": user.Password || "-",
                        "Cities": cityDetails || "-",
                        "Zones": zoneDetails || "-",
                        "Police Station": policeStationDetails || "-",
                        "Areas": areaDetails || "-",
                        "Date And Time": user.CreatedByDateTime || "-",
                        "Address": user.Address || "-"
                    };
                });

                exportToExcel(exportData, "User_Details");
            },

            onError: () => {
                notifyError("Export failed. Please try again.");
            },
        });
    };

    // const isCityLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "cityuser";
    // const isZoneLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "zoneuser";
    // const isPSLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "policestationuser";
    const isCityLogin = true;
    const isZoneLogin = true;
    const isPSLogin = true;

    const { data: zoneData = [] } = useZoneData(modelFilter?.cityID, Cookies.get("NIGHT_EYE_ZONE_ID"));
    const { data: policeStationData = [] } = usePoliceStationData(modelFilter?.cityID, modelFilter?.zoneID, Cookies.get("NIGHT_EYE_POLICE_STATION_ID"));
    const { data: areaData = [] } = useAreaData(modelFilter?.cityID, modelFilter.zoneID, modelFilter?.policeStationID, Cookies.get("NIGHT_EYE_AREA_ID"));

    const zoneOptions = zoneData?.map((ele) => ({
        value: ele?.ZoneID,
        label: ele?.ZoneName,
    }));
    const policeStationOptions = policeStationData?.map((ele) => ({
        value: ele?.PoliceStationID,
        label: ele?.PoliceStation,
    }));
    const areaOptions = areaData?.map((ele) => ({
        value: ele?.AreaID,
        label: ele?.AreaName,
    }));

    useEffect(() => {
        if (isZoneLogin && zoneOptions.length == 1) {
            setFilterData((prev) => {
                return {
                    ...prev,
                    zoneID: zoneOptions?.[0].value || "",
                };
            });
        } else if (isPSLogin && policeStationOptions.length == 1) {
            setFilterData((prev) => {
                return {
                    ...prev,
                    policeStationID: policeStationOptions?.[0].value || "",
                };
            });
        }
    }, []);

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: "38px",
            backgroundColor: "rgb(248 250 252)",
            borderColor: state.isFocused ? "#3b82f6" : "rgb(226 232 240)",
            boxShadow: state.isFocused ? "0 0 0 3px rgba(59,130,246,0.15)" : "none",
            borderRadius: "0.5rem",
            "&:hover": { borderColor: "#94a3b8" },
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "2px 12px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#1e293b",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#94a3b8",
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: "0.5rem",
            boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
        }),
    };

    const handleSelectFilterData = (name, value) => {
        if (name == "zoneID") {
            setModelFilter((prev) => {
                return {
                    ...prev,
                    [name]: value,
                    policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
                    areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
                };
            });
        } else if (name == "policeStationID") {
            setModelFilter((prev) => {
                return {
                    ...prev,
                    [name]: value,
                    areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
                };
            });
        } else {
            setModelFilter((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
        }
    };
    const handleReset = () => {
        setFilterData({
            cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
            zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
            policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
            areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
            userName: "",
            startDate: "",
            endDate: "",
        });
        setModelFilter({
            cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
            zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
            policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
            areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
            userName: "",
            startDate: "",
            endDate: ""
        });
    };



    const onReportModelclose = () => {
        setIsReportModalOpen(false);
        setSelectedShop();
    };

    const handleCloseShopDetails = () => {
        setShopProfileDetailView();
        setOpenShopDetails(false);
    };


    const handleEditUser = (user) => {
        dispatch(handleEditUserID(user.UserID))
        navigate(`/${mainRouteInitial}/AddUser`);
    };


    return (
        <main className="flex-1 overflow-y-auto p-3 md:px-8 scroll-smooth">
            <div className="mx-auto max-w-7xl flex flex-col gap-3">
                {/* Filters & Map Toolbar */}
                <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
                    {/* Header with title + toggle + optional reset icon */}
                    <div className="px-4 sm:px-6 py-0 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
                        <div className="flex items-center gap-2.5">
                            <span className="material-symbols-outlined text-blue-600 text-2xl">filter_list</span>
                            <h3 className="text-base font-semibold text-slate-800 dark:text-slate-100">Filters</h3>
                            <span className="text-[14px] text-slate-500 dark:text-slate-400 countcss">{totalCount}</span>
                        </div>

                        <div className="flex items-center gap-1.5 sm:gap-2">
                            {/* Collapse / Expand Button */}
                            <button
                                onClick={() => setIsFiltersOpen((prev) => !prev)}
                                title={isFiltersOpen ? "Collapse filters" : "Expand filters"}
                                className="p-1.5 sm:p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors"
                            >
                                <span className="material-symbols-outlined text-xl sm:text-2xl">{isFiltersOpen ? "expand_less" : "expand_more"}</span>
                            </button>

                            {/* Optional: small reset icon in header */}
                            <button
                                onClick={handleReset}
                                title="Reset filters"
                                className="p-1.5 sm:p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors hidden sm:block"
                            >
                                <span className="material-symbols-outlined text-xl sm:text-2xl">restart_alt</span>
                            </button>
                        </div>
                    </div>

                    {/* Collapsible content */}
                    {isFiltersOpen && (
                        <div className="p-4 sm:p-6 transition-all duration-200 ease-in-out">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                                {/* Zone */}
                                {(isCityLogin || isZoneLogin) && (
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Zone</label>
                                        <Select
                                            options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_ZONE_ID") || "" }, ...zoneOptions]}
                                            value={zoneOptions.find((opt) => opt.value === modelFilter?.zoneID) || null}
                                            onChange={(opt) => handleSelectFilterData("zoneID", opt?.value || "")}
                                            placeholder="Select Zone"
                                            styles={selectStyles}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                )}

                                {/* Police Station */}
                                {(isCityLogin || isZoneLogin || isPSLogin) && (
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Police Station</label>
                                        <Select
                                            options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "" }, ...policeStationOptions]}
                                            value={policeStationOptions.find((opt) => opt.value === modelFilter?.policeStationID) || null}
                                            onChange={(opt) => handleSelectFilterData("policeStationID", opt?.value || "")}
                                            placeholder="Select Police Station"
                                            styles={selectStyles}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                )}

                                {/* Area */}
                                {(isCityLogin || isZoneLogin || isPSLogin) && (
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Area</label>
                                        <Select
                                            options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_AREA_ID") || "" }, ...areaOptions]}
                                            value={areaOptions.find((opt) => opt.value === modelFilter?.areaID) || null}
                                            onChange={(opt) => handleSelectFilterData("areaID", opt?.value || "")}
                                            placeholder="Select Area"
                                            styles={selectStyles}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                )}

                                <div className="flex flex-col gap-1.5">
                                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">User Name</label>
                                    <input
                                        type="text"
                                        value={modelFilter?.userName || ""}
                                        onChange={(e) => handleSelectFilterData("userName", e.target.value)}
                                        placeholder="Search owner name..."
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                    />
                                </div>



                                {/* Start Date */}
                                <div className="flex flex-col gap-1.5">
                                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Start Date</label>
                                    <Flatpickr
                                        options={{ dateFormat: "d-m-Y" }}
                                        value={modelFilter?.startDate}
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                        onChange={(e) => handleSelectFilterData("startDate", e?.[0])}
                                        placeholder="DD-MM-YYYY"
                                    />
                                </div>

                                {/* End Date */}
                                <div className="flex flex-col gap-1.5">
                                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">End Date</label>
                                    <Flatpickr
                                        options={{ dateFormat: "d-m-Y" }}
                                        value={modelFilter?.endDate}
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                        onChange={(e) => handleSelectFilterData("endDate", e?.[0])}
                                        placeholder="DD-MM-YYYY"
                                    />
                                    {!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate) && (
                                        <p className="text-xs text-red-600 dark:text-red-400 mt-1">End date cannot be before start date</p>
                                    )}
                                </div>
                                <div className="flex flex-col flex-nowrap gap-1.5">
                                    {/* <button
                    onClick={handleReset}
                    className="px-5 py-2.5 text-sm font-medium rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors min-w-[100px]"
                >
                    Reset
                </button> */}
                                    <div className="flex justify-start mt-5">
                                        <button
                                            onClick={handleFilterSearch}
                                            disabled={!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)}
                                            className="px-4 py-2.5 mr-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed min-w-[100px]  "
                                        >
                                            Filter
                                        </button>

                                        <button
                                            onClick={handleExport}
                                            disabled={isExporting}
                                            className="px-4 py-2.5 text-sm font-medium bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed min-w-[100px] flex items-center justify-center gap-2"
                                        >
                                            {isExporting ? <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" /> : "Excel"}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                        </div>
                    )}
                </div>


                <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-lg border border-slate-200/80 dark:border-slate-700/50 overflow-hidden">
                    <div className="m-2">
                        <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />
                    </div>
                    <div className="overflow-x-auto">
                        {isLoading || isFetching ? (
                            <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-800">
                                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                                    <tr>
                                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">Sr No</th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Status</th>
                                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                                            Name / Mobile / Username
                                        </th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Role / Password</th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Areas & Jurisdictions</th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Created / Address</th>

                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100 dark:divide-slate-800/70">
                                    {[...Array(5)].map((_, i) => (
                                        <ShimmerRow key={i} /> // your shimmer component
                                    ))}
                                </tbody>
                            </table>
                        ) : currentItems.length === 0 ? (
                            <NoDataFound />
                        ) : (
                            <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
                                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                                    <tr>
                                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">Sr No</th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Status</th>
                                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                                            Name / Mobile / Username
                                        </th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Role / Password</th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">City / Zone / Police Station / Area</th>
                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Created / Address</th>

                                        <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Actions</th>
                                    </tr>
                                </thead>

                                <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                                    {currentItems.map((user, idx) => {
                                        const absoluteIndex = idx + 1;
                                        const isActive = user.IsActive === true || user.IsActive === "true";

                                        const imageUrl = user.UserImage
                                            ? `${NIGHT_EYE_IMG_URL}/users/${user.UserImage}` // adjust path if needed
                                            : null;

                                        return (
                                            <React.Fragment key={user.UserID || idx}>
                                                <tr className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                                    {/* Sr No */}
                                                    <td className="py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                                                        {absoluteIndex}
                                                    </td>

                                                    {/* Status */}
                                                    <td className="px-3 py-4 text-sm">
                                                        <span
                                                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${isActive
                                                                ? "bg-green-100 text-green-800 dark:bg-green-800/30 dark:text-green-300"
                                                                : "bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-300"
                                                                }`}
                                                        >
                                                            {isActive ? "Active" : "Inactive"}
                                                        </span>
                                                    </td>

                                                    {/* Name / Mobile / Username */}
                                                    <td className="py-4 pl-4 pr-3 text-sm sm:pl-6">
                                                        <div className="flex flex-col space-y-1">
                                                            <div className="font-medium text-slate-900 dark:text-white">
                                                                {user.Name || "—"}
                                                            </div>
                                                            <div className="text-sm text-slate-500 dark:text-slate-400">
                                                                {user.MobileNo || "—"}
                                                            </div>
                                                            <div className="text-xs text-slate-500 dark:text-slate-400 italic">
                                                                @{user.UserName || "—"}
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Role / Password */}
                                                    <td className="px-3 py-4 text-sm">
                                                        <div className="flex flex-col space-y-1">
                                                            <div className="font-medium text-slate-900 dark:text-white">
                                                                {user?.UserRoleDetail?.[0]?.UserRole || "Not assigned"}
                                                            </div>
                                                            <div className="text-xs text-slate-600 dark:text-slate-400">
                                                                Password: {user.Password ? "••••••••" : "—"}
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Areas & Jurisdictions */}
                                                    <td className="px-3 py-4 text-sm">
                                                        <div className="space-y-2 text-sm">
                                                            {/* Cities */}
                                                            {user.UserCityDetail?.length > 0 && (
                                                                <div>
                                                                    <span className="font-semibold text-slate-700 dark:text-slate-300">Cities:</span>
                                                                    <div className="flex flex-wrap gap-1 mt-1">
                                                                        {user.UserCityDetail.map((c) => (
                                                                            <span
                                                                                key={c.CityID}
                                                                                className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
                                                                            >
                                                                                {c.CityName}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Zones */}
                                                            {user.UserZoneDetail?.length > 0 && (
                                                                <div>
                                                                    <span className="font-semibold text-slate-700 dark:text-slate-300">Zones:</span>
                                                                    <div className="flex flex-wrap gap-1 mt-1">
                                                                        {user.UserZoneDetail.map((z) => (
                                                                            <span
                                                                                key={z.ZoneID}
                                                                                className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
                                                                            >
                                                                                {z.ZoneName}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {user.UserPoliceStationDetail?.length > 0 && (
                                                                <div>
                                                                    <span className="font-semibold text-slate-700 dark:text-slate-300">Police Station:</span>
                                                                    <div className="flex flex-wrap gap-1 mt-1">
                                                                        {user.UserPoliceStationDetail.map((z) => (
                                                                            <span
                                                                                key={z.PoliceStationID}
                                                                                className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
                                                                            >
                                                                                {z.PoliceStation}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {user.UserAreaDetail?.length > 0 && (
                                                                <div>
                                                                    <span className="font-semibold text-slate-700 dark:text-slate-300">Areas:</span>
                                                                    <div className="flex flex-wrap gap-1 mt-1">
                                                                        {user.UserAreaDetail.map((z) => (
                                                                            <span
                                                                                key={z.AreaID}
                                                                                className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
                                                                            >
                                                                                {z.AreaName}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}


                                                        </div>
                                                    </td>

                                                    {/* Created / Address */}
                                                    <td className="px-3 py-4 text-sm">
                                                        <div className="flex flex-col space-y-1">
                                                            <div className="text-slate-600 dark:text-slate-400 text-xs">
                                                                Created: {user.CreatedByDateTime || "—"}
                                                            </div>
                                                            <div className="text-slate-700 dark:text-slate-300">
                                                                {user.Address || "—"}
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Photo */}
                                                    {/* <td className="px-3 py-4 whitespace-nowrap">
                                                        {imageUrl ? (
                                                            <div
                                                                className="h-14 w-14 rounded-lg bg-cover bg-center border border-slate-200 dark:border-slate-600 cursor-pointer hover:ring-2 hover:ring-blue-500 transition-all"
                                                                style={{ backgroundImage: `url(${imageUrl})` }}
                                                                onClick={() => openModal(imageUrl)} // your modal function
                                                            />
                                                        ) : (
                                                            <div className="h-14 w-14 rounded-lg bg-slate-100 dark:bg-slate-700 flex items-center justify-center text-slate-400">
                                                                <span className="material-symbols-outlined text-2xl">person</span>
                                                            </div>
                                                        )}
                                                    </td> */}

                                                    {/* Actions */}
                                                    <td className="">
                                                        <div className="mt-3 px-2">

                                                            <button
                                                                onClick={() => handleEditUser(user)}
                                                                className="flex items-center gap-1.5 w-full justify-center px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-primary bg-primary-600 rounded-lg hover:bg-primary-700 shadow-sm shadow-primary-500/30 transition-colors"
                                                            >
                                                                <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                                                                Edit
                                                            </button>
                                                            {/* <button
                                                                onClick={() => handleVendorReport(user)}
                                                                className="flex items-center gap-1.5 w-full justify-center px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-red-600 rounded-lg hover:bg-red-700 shadow-sm shadow-red-500/30 transition-colors"
                                                            >
                                                                <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                                                                Delet
                                                            </button> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-4 sm:px-6 py-4">
                    <PageEntries start={start} end={end} totalCount={totalCount} />

                    <PaginationButtons currentPage={currentPage} setCurrentPage={setCurrentPage} goToPage={goToPage} pages={pages} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} />
                </div>
                {selectedImage && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={closeModal}>
                        <div className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
                            {/* Close button */}
                            <button
                                className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
                                onClick={closeModal}
                                aria-label="Close modal"
                            >
                                <span className="material-symbols-outlined">close</span>
                            </button>

                            {/* Image */}
                            <img
                                src={selectedImage}
                                alt="Full size shop close proof"
                                className="w-full h-full object-contain bg-slate-900"
                                onError={(e) => {
                                    e.target.src = "/fallback-large-placeholder.jpg";
                                }}
                            />
                        </div>
                    </div>
                )}
                {isReportModalOpen && <ShopReportModal isOpen={isReportModalOpen} refetch={refetch} onClose={onReportModelclose} selectedShop={selectedShop} />}
                {openShopDetails && <ShopDetailModal shop={shopProfileDetailView} isOpen={openShopDetails} onClose={handleCloseShopDetails} />}
            </div>
        </main>
    );
};

export default ViewUserList;
